export enum CandidateAvailabilityState {
  NotDefined = 0,
  Yes = 1,
  No = 2,
}
